import { render, staticRenderFns } from "./EntryPrivate.vue?vue&type=template&id=0f827bdc&scoped=true"
import script from "./EntryPrivate.vue?vue&type=script&lang=js"
export * from "./EntryPrivate.vue?vue&type=script&lang=js"
import style0 from "./EntryPrivate.vue?vue&type=style&index=0&id=0f827bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f827bdc",
  null
  
)

export default component.exports